import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/categories';

export default function SEOArticlesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="container-page">
        <div className="mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            AllChinaBuy Spreadsheet Guides & Articles
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg">
            In-depth guides and articles to help you master the AllChinaBuy Spreadsheet. From trusted sellers to shipping tutorials, we cover everything you need.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/60 cursor-pointer hover:border-primary-300 overflow-hidden transition-all duration-200"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-800 text-[10px] font-semibold">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col gap-2 p-4 md:p-5 flex-1">
                <div className="flex items-center gap-2">
                  <span className="text-[10px] text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug group-hover:text-primary-700 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 mt-1">
                  Read Article
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/articles/shopping-guide-2026"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-xl text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            View All Guides
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}